module.exports = __webpack_public_path__ + "static/media/ai-agents-es.bea62d85.png";